var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(-679 -4925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1163",
    "data-name": "Rectangle 1163",
    width: 77,
    height: 77,
    transform: "translate(679 4925)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sports",
    transform: "translate(687 4933)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    width: 61,
    height: 61,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-sports-2039522",
    d: "M119.435,64.213h-.11a15.784,15.784,0,0,1-8.815-3.636l21.707-21.818a16.455,16.455,0,0,1,3.636,8.925v.22a17.528,17.528,0,0,0-11.239,5.179A17.811,17.811,0,0,0,119.435,64.213ZM105,50v-.331a17.528,17.528,0,0,0,11.239-5.179,18.093,18.093,0,0,0,5.179-11.239.108.108,0,0,0,.11.11h.331A15.448,15.448,0,0,1,130.454,37L108.636,58.814A15.045,15.045,0,0,1,105,50Zm4.518-12.121a15.658,15.658,0,0,1,9.476-4.518,15.244,15.244,0,0,1-4.408,9.476,15.52,15.52,0,0,1-9.476,4.408A14.144,14.144,0,0,1,109.518,37.878ZM131.335,59.7a15.658,15.658,0,0,1-9.476,4.518,15.244,15.244,0,0,1,4.408-9.476,15.52,15.52,0,0,1,9.476-4.408A14.144,14.144,0,0,1,131.335,59.7Z",
    transform: "translate(-104.906 -32.909)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(24.377 24.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M154.706,28.173a18.841,18.841,0,0,1,4.115,11.108h8.862V21.81a18.211,18.211,0,0,0-13.029,6.3Z",
    transform: "translate(-150.218 -21.81)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M360.715,39.28h8.862a18.843,18.843,0,0,1,4.115-11.108l.053-.067a18.213,18.213,0,0,0-13.031-6.3Z",
    transform: "translate(-341.728 -21.809)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M507.77,138.345h7.091A18.141,18.141,0,0,0,511.4,128.4a17.33,17.33,0,0,0-3.626,9.945Z",
    transform: "translate(-478.399 -120.874)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M507.77,290.78a17.327,17.327,0,0,0,3.626,9.943,18.14,18.14,0,0,0,3.465-9.943Z",
    transform: "translate(-478.399 -271.788)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M91.812,290.78a18.145,18.145,0,0,0,3.46,9.94,17.33,17.33,0,0,0,3.623-9.94Z",
    transform: "translate(-91.812 -271.788)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M373.7,301.888a18.841,18.841,0,0,1-4.115-11.108h-8.862V308.25a18.214,18.214,0,0,0,13.03-6.3Z",
    transform: "translate(-341.737 -271.788)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M167.7,290.78H158.84a18.842,18.842,0,0,1-4.115,11.108l-.05.063a18.211,18.211,0,0,0,13.028,6.3Z",
    transform: "translate(-150.235 -271.788)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M95.27,128.45a18.142,18.142,0,0,0-3.46,9.941h7.084A17.332,17.332,0,0,0,95.27,128.45Z",
    transform: "translate(-91.81 -120.92)",
    fill: "#016dd9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/Ball.041ad7996245fc72f47fd790943fc85a.svg";
export { ForwardRef as ReactComponent };